import { BYTES_PER_KB } from "./constants";

export function prettySize(bytes) {
  if (!bytes) return "—";
  const kb = bytes / BYTES_PER_KB;
  if (kb < BYTES_PER_KB) return `${kb.toFixed(1)} KB`;
  return `${(kb / BYTES_PER_KB).toFixed(2)} MB`;
}

export function formatTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function resultsToCsv(results) {
  const header = [
    "parcel_id",
    "normalized",
    "status",
    "determination_code",
    "determination_label",
    "address",
    "date",
    "range_slug",
    "pdf_filename",
    "message",
  ];
  const rows = results.map((r) =>
    header
      .map((k) => {
        const v = r[k] ?? "";
        const s = String(v).replace(/"/g, '""');
        return /[",\n]/.test(s) ? `"${s}"` : s;
      })
      .join(","),
  );
  return [header.join(","), ...rows].join("\n");
}

export function countByStatus(results) {
  const c = { FOUND: 0, NOT_FOUND: 0, INVALID: 0, NO_RANGE: 0, ERROR: 0 };
  for (const r of results) c[r.status] = (c[r.status] || 0) + 1;
  return c;
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
